import React, { useRef } from 'react';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import { isOverFileSize } from '../../common/helper';
export const InputFile = (props) => {
    const { t } = useTranslation();
    const reactAlert = useAlert();
    const inputRef = useRef(null);
    const onChangeInput = (event, onChange) => {
        if (event.target.files && event.target.files.length > 0 && onChange) {
            const file = event.target.files[0];
            if (isOverFileSize(file)) {
                reactAlert.error(t('ファイルサイズは5MB以内にしてください。'));
                const tempRef = inputRef.current;
                tempRef.value = '';
                return;
            }
            const fileReader = new FileReader();
            fileReader.onload = () => {
                onChange(file, fileReader.result);
            };
            fileReader.readAsDataURL(file);
        }
    };
    return (React.createElement("input", { ref: inputRef, type: "file", disabled: props.disabled, onChange: (event) => onChangeInput(event, props.onChange) }));
};
